import { getAgenteAccessToken } from "@/services/tokens.service";
import { mainAxios } from "@/mainAxios";

export const getTableRender = async (leadData) => {
    const config = {
        headers: {
            Authorization: "Bearer " + getAgenteAccessToken(),
        },
    };

    const serverResponse = await mainAxios.post(
        "/v1/lead-segurify/fetch-realtime-table",
        leadData,
        config
    );

    return serverResponse.data;
};